export default __webpack_public_path__ + "static/media/my_pr_bottom.b42976a9.ee439761.svg";